export type AmplitudeOfferPromotionLocation = "investment_page" | "property_page" | "listing_page";

export type AmplitudeOfferPromotionCreativeSlot = "modal" | "cta_box" | "promotion_box" | "header_promotion_badge" | "promotion_tab_listing";

export interface IAmplitudeOfferPromotionTrackingParams {
    creativeName: string | string[];
    creativeSlot: AmplitudeOfferPromotionCreativeSlot;
    promotionId?: number | number[];
    promotionName: string | string[];
    promotionContent?: string | string[] | null;
    location: AmplitudeOfferPromotionLocation;
    itemListId?: string;
    itemId?: number;
    propertyId?: number;
}

export type IAmplitudeOfferPromotionTrackingParamsWithItemId = IAmplitudeOfferPromotionTrackingParams & {
    itemId: number;
};

export const getAmplitudeOfferPromotionEventProperties = (params: IAmplitudeOfferPromotionTrackingParams) => ({
    creative_name: params.creativeName,
    creative_slot: params.creativeSlot,
    promotion_name: params.promotionName,
    location: params.location,
    ...(params.promotionId != null && {promotion_id: params.promotionId}),
    ...(params.promotionContent && {promotion_content: params.promotionContent}),
    ...(params.itemListId && {item_list_id: params.itemListId}),
    ...(params.itemId != null && {item_id: params.itemId}),
    ...(params.propertyId != null && {property_id: params.propertyId})
});
export type AmplitudeOfferPromotionLocation = "investment_page" | "property_page" | "listing_page";

export type AmplitudeOfferPromotionCreativeSlot = "modal" | "cta_box" | "promotion_box" | "header_promotion_badge" | "promotion_tab_listing";

export interface IAmplitudeOfferPromotionTrackingParams {
    creativeName: string | string[];
    creativeSlot: AmplitudeOfferPromotionCreativeSlot;
    promotionId?: number | number[];
    promotionName: string | string[];
    promotionContent?: string | string[] | null;
    location: AmplitudeOfferPromotionLocation;
    itemListId?: string;
    itemId?: number;
    propertyId?: number;
}

export type IAmplitudeOfferPromotionTrackingParamsWithItemId = IAmplitudeOfferPromotionTrackingParams & {
    itemId: number;
};

export const getAmplitudeOfferPromotionEventProperties = (params: IAmplitudeOfferPromotionTrackingParams) => ({
    creative_name: params.creativeName,
    creative_slot: params.creativeSlot,
    promotion_name: params.promotionName,
    location: params.location,
    ...(params.promotionId != null && {promotion_id: params.promotionId}),
    ...(params.promotionContent && {promotion_content: params.promotionContent}),
    ...(params.itemListId && {item_list_id: params.itemListId}),
    ...(params.itemId != null && {item_id: params.itemId}),
    ...(params.propertyId != null && {property_id: params.propertyId})
});
